import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ReactNode } from "react";

type ListPageTopBarType = {
  title: string;
  children: ReactNode;
  leftSideComponent?: ReactNode;
};
export const DetailsPageTopBar = ({
  title,
  children,
  leftSideComponent,
}: ListPageTopBarType) => {
  return (
    <div className="document-header-wrapper">
      <Card className="flex md:items-center justify-between md:flex-row flex-col md:pb-0 pb-3 document-header pl-3 !py-3">
        <div className="flex items-center h-full py-0  for-big">
          <CardTitle>{title}</CardTitle>

          <div className="flex gap-1 items-center pl-5 md:pl-0 mb-4 md:mb-0">
            {leftSideComponent}
          </div>
        </div>
        <CardContent className="flex items-center h-full py-0  gap-1 flex-wrap for-mob-wrapper">
          <>
            <CardHeader className="md:pt-5 md:pl-4 for-mob">
              <CardTitle>{title}</CardTitle>
            </CardHeader>
            <div className="flex gap-1 items-center pl-5 md:pl-0 mb-4 md:mb-0 for-mob">
              {leftSideComponent}
            </div>
          </>
          {children}
        </CardContent>
      </Card>
    </div>
  );
};

// import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { ReactNode } from "react";

// type ListPageTopBarType = {
//   title: string;
//   children: ReactNode;
//   leftSideComponent?: ReactNode;
// };
// export const DetailsPageTopBar = ({
//   title,
//   children,
//   leftSideComponent,
// }: ListPageTopBarType) => {
//   return (
//     <div className="document-header-wrapper">
//       <Card className="flex md:items-center justify-between md:flex-row flex-col md:pb-0 pb-3 document-header pl-5 !py-3">
//         <div className="flex items-center h-full py-0  gap-3 for-big">
//           <CardTitle>{title}</CardTitle>

//           <div className="flex gap-1 items-center pl-5 md:pl-0 mb-4 md:mb-0">
//             {leftSideComponent}
//           </div>
//         </div>
//         <CardContent className="flex items-center h-full py-0  gap-1 flex-wrap for-mob-wrapper">
//           <>
//             <CardHeader className="md:pt-5 md:pl-4 for-mob">
//               <CardTitle>{title}</CardTitle>
//             </CardHeader>
//             <div className="flex gap-1 items-center pl-5 md:pl-0 mb-4 md:mb-0 for-mob">
//               {leftSideComponent}
//             </div>
//           </>
//           {children}
//         </CardContent>
//       </Card>
//     </div>
//   );
// };
